import { Box } from "@mui/material";
import CustomDialog from "components/CustomDialog";
import SimpleBarScroll from "components/SimpleBar";
import React from "react";
import SmsProviderCreate from "../SmsProviderCreate";

const SmsProviderEditDialog = ({ open, handleClose, item }) => {
  return (
    <CustomDialog
      forceFullScreen={true}
      open={open}
      handleClose={handleClose}
      heading="Edit payment"
    >
      <Box sx={{ overflow: "hidden" }}>
        <SimpleBarScroll>
          <Box padding={2}>
            <SmsProviderCreate item={item} fullGrid={false}/>
          </Box>
        </SimpleBarScroll>
      </Box>
    </CustomDialog>
  );
};

export default SmsProviderEditDialog;
